import React from "react";
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";

function ServiceCaseWorkForm(props) {
    const formContent = (data, update) => (
        <>
            <StringInput name={'Kod_Prace'} label={'Kód Práce'} value={data.Kod_Prace} onChange={update}/>
            <StringInput name={'Popis'} label={'Popis'} value={data.Popis} onChange={update}/>
            <StringInput name={'Cena'} label={'Cena'} value={data.Cena} onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Vykonaná práca"
                     labelNew="Pridať Vykonanú prácu"
                     baseUrl='/service_case/service_cases_works/'
                     formContent={formContent}/>
    )
}

export default ServiceCaseWorkForm
